import React from 'react';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import SettingsIcon from '@mui/icons-material/Settings';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import CheckIcon from '@mui/icons-material/Check';

const Einstellungen = (props) => {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpen = event => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };


    return (
        <div style={{textAlign:"right"}}>
            <Button
                aria-haspopup="true"
                aria-controls="lock-menu-einstellungen"
                aria-label="when device is locked"
                onClick={handleOpen}
                color="primary"
            >
               <SettingsIcon />&nbsp;Einstellungen
            </Button>
            <Menu
                id="lock-menu-einstellungen"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <div>
                    {pane(props.themes, props.activeTheme, props.updateTheme, handleClose)}
                </div>
            </Menu>
        </div>
    );
}

const pane = (themes, activeTheme, updateTheme, handleClose) => {
    return (
            <List>
                  <ListSubheader>Farbschema</ListSubheader>

                {Object.keys(themes).map(
                    el => <ListItem 
                        key={"einstellungen_theme_"+el}
                        button
                        onClick={
                            ()=>{
                                updateTheme('meta.theme',el)
                                handleClose()
                            }
                        }
                    >
                        {activeTheme == el &&
                            <ListItemIcon>
                                <CheckIcon  color="primary" />   
                            </ListItemIcon>
                        }
                        {activeTheme == el
                            ?<ListItemText primary={themes[el].name} />
                            :<ListItemText inset primary={themes[el].name} />
                        }
                    </ListItem>
                )}
            </List>

    )
}

export default Einstellungen;